<h2 mat-dialog-title>Game exported with warnings</h2>
<mat-dialog-content>
  <p>
    The game was synced to the Data Cockpit, but the following reference(s)
    could not be resolved to a Master ID and were omitted. Please fix them and
    re-sync.
  </p>
  <table class="warnings-table">
    <thead>
      <tr>
        <th>Type</th>
        <th>ID</th>
        <th>Name</th>
        <th>Issue</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let warning of warnings">
        <td>{{ warning.type }}</td>
        <td>{{ warning.id }}</td>
        <td>{{ warning.name || '—' }}</td>
        <td>
          <mat-icon class="warning">warning</mat-icon>
          {{ warning.reason }}
        </td>
      </tr>
    </tbody>
  </table>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="true">Close</button>
</mat-dialog-actions>
